import { SHIFT_APPLICATION_FRAGMENT } from '../fragments/shift-application-fragment';
import { gql } from 'apollo-boost';

export const SHIFT_APPLICATION_FAILED_TO_ATTEND_GQL = gql`
  ${SHIFT_APPLICATION_FRAGMENT}
  mutation ShiftApplicationFailedToAttend($idArray: [ID!]!) {
    shift_application_failed_to_attend(input: { ids: $idArray }) {
      failures {
        id
        message
      }
      successes {
        message
        shift_application {
          ...shiftApplicationFragment
        }
      }
    }
  }
`;

export const SHIFT_APPLICATION_FAILED_TO_ATTEND_CANCEL_GQL = gql`
  ${SHIFT_APPLICATION_FRAGMENT}
  mutation ShiftApplicationFailedToAttendCancel($idArray: [ID!]!) {
    shift_application_failed_to_attend_cancel(input: { ids: $idArray }) {
      failures {
        id
        message
      }
      successes {
        message
        shift_application {
          ...shiftApplicationFragment
        }
      }
    }
  }
`;
